// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__Bm_0k","legacyBtn":"MutateMid_legacyBtn__2d2SQ"};